import { Events, UnityBridge } from "@Context/common/general/context";
import { Tooltip } from "@mui/material";
import React, { ReactElement, cloneElement } from "react";

interface IHapticsButtonWrapper {
  children: ReactElement;
  disabled?: boolean;
  tooltip?: string;
}

const HapticsButtonWrapper = ({ children, disabled = false, tooltip }: IHapticsButtonWrapper) => {
  const onClickSound = () => {
    Events.audio.playSound.emit({ src: "button_press", volume: 1 });
    haptics();
  };

  const haptics = () => {
    UnityBridge.dispatchWebEvent({
      type: UnityBridge.OutgoingWebEvents.TriggerHaptics,
      payload: {
        frequency: 0.25,
        amplitude: 0.1,
        duration: 0.15,
      },
    });
  };

  const enhanceChild = (child: ReactElement) => {
    const originalOnClick = child.props.onClick;
    const originalOnMouseEnter = child.props.onMouseEnter;

    // Wrap the original event handler with additional functionality
    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
      if (!disabled) {
        onClickSound();
      }

      if (originalOnClick) {
        originalOnClick(e);
      }
    };

    const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
      if (!disabled) {
        haptics();
      }

      if (originalOnMouseEnter) {
        originalOnMouseEnter(e);
      }
    };

    return cloneElement(child, {
      onClick: handleClick,
      onMouseEnter: handleMouseEnter,
    });
  };

  if (tooltip) {
    return <Tooltip title={tooltip}>{enhanceChild(children)}</Tooltip>;
  }

  // Assuming only one child, but could be adapted for multiple children
  return enhanceChild(children);
};

export default HapticsButtonWrapper;
